import qs from 'qs'
import axios from 'axios'
export function ajax(url, type, params, headers) {
    let promise;
    return new Promise(function(resolve, reject) {

        if (type === 'GET') {
            promise = axios.get(url, {
                params: params
            })
        } else {
            if (headers) {
                promise = axios.post(
                    url,
                    params, {
                        headers: headers
                    }
                );
            } else {
                promise = axios.post(
                    url,
                    qs.stringify(params), {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    }
                );
            }


        }
        promise.then(function(res) {
            resolve(res.data);
        }).catch(function() {
            reject('服务器异常');
        })



    });
}